export type Country =
    | 'Australia'
    | 'Canada'
    | 'New Zealand'
    | 'Singapore'
    | 'South Africa'
    | 'United States'

export const countries = [
    {
        name: 'Australia',
        abbreviation: 'AU',
    },
    {
        name: 'Canada',
        abbreviation: 'CA',
    },
    {
        name: 'New Zealand',
        abbreviation: 'NZ',
    },
    {
        name: 'Singapore',
        abbreviation: 'SG',
    },
    {
        name: 'South Africa',
        abbreviation: 'ZA',
    },
    {
        name: 'United States',
        abbreviation: 'USA',
    },
]

export const supportedAutoCompleteCountries: Country[] = [
    'United States',
    'Canada',
    'Australia',
    'New Zealand',
    'Singapore',
    'South Africa',
]
